export const manifest = {
  screens: {
    scr_hero: { name: "Hero", route: "/", position: {"x":160,"y":220} },
    scr_pain: { name: "Pain", route: "/", state: {"section":"pain"}, position: {"x":1560,"y":220} },
    scr_solution: { name: "Solution", route: "/", state: {"section":"solution"}, position: {"x":2960,"y":220} },
    scr_bonuses: { name: "Bonuses", route: "/", state: {"section":"bonuses"}, position: {"x":4360,"y":220} },
    scr_pricing: { name: "Pricing Packs", route: "/", state: {"section":"pricing"}, position: {"x":5760,"y":220} },
    scr_guarantee: { name: "Guarantee", route: "/", state: {"section":"guarantee"}, position: {"x":7160,"y":220} },
  },
  sections: {
    sec_612p3p: { name: "Landing Page Flow", x: 0, y: 0, width: 8520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_612p3p", children: [
      { kind: "screen", id: "scr_hero" },
      { kind: "screen", id: "scr_pain" },
      { kind: "screen", id: "scr_solution" },
      { kind: "screen", id: "scr_bonuses" },
      { kind: "screen", id: "scr_pricing" },
      { kind: "screen", id: "scr_guarantee" },
    ] },
  ],
}
